var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadMapPinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3867 30.3013L15.48 30.3547L15.5173 30.376C15.6654 30.4561 15.831 30.498 15.9993 30.498C16.1676 30.498 16.3333 30.4561 16.4813 30.376L16.5187 30.356L16.6133 30.3013C17.1348 29.9921 17.6437 29.6621 18.1387 29.312C19.4201 28.4073 20.6174 27.389 21.716 26.2693C24.308 23.616 27 19.6293 27 14.5C27 11.5826 25.8411 8.78473 23.7782 6.72183C21.7153 4.65893 18.9174 3.5 16 3.5C13.0826 3.5 10.2847 4.65893 8.22183 6.72183C6.15893 8.78473 5 11.5826 5 14.5C5 19.628 7.69333 23.616 10.284 26.2693C11.3822 27.3889 12.579 28.4072 13.86 29.312C14.3554 29.6621 14.8647 29.9921 15.3867 30.3013ZM16 18.5C17.0609 18.5 18.0783 18.0786 18.8284 17.3284C19.5786 16.5783 20 15.5609 20 14.5C20 13.4391 19.5786 12.4217 18.8284 11.6716C18.0783 10.9214 17.0609 10.5 16 10.5C14.9391 10.5 13.9217 10.9214 13.1716 11.6716C12.4214 12.4217 12 13.4391 12 14.5C12 15.5609 12.4214 16.5783 13.1716 17.3284C13.9217 18.0786 14.9391 18.5 16 18.5Z",
    fill: "#AF7FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadMapPinkIcon);
export default __webpack_public_path__ + "static/media/roadMapPinkIcon.0309fcd59b86e8ea33528649d99e4ba5.svg";
export { ForwardRef as ReactComponent };